// extracted by mini-css-extract-plugin
export default {"header":"cardHeader_header__GI4yN"};